import React from 'react';
import { injectIntl } from 'react-intl';
import {
  LoginForgot,
  LoginForm,
  LoginFormGroup,
  LoginInput,
  LoginSubmit,
  SwitchPassword,
} from '..';
import { Auth } from '../../../utils/utils.api';
import { getErrorMessage } from '../../../utils/errorMessage';
import { InjectedIntlProps } from '../../../doctrine.types';
import { ConnectionError } from './ConnectionError';

type Props = InjectedIntlProps & {
  switchToForgotPassword: (
    event: React.MouseEvent<HTMLSpanElement, MouseEvent>,
  ) => void;
};

type State = {
  email: string;
  password: string;
  shoulShowPassword: boolean;
  isLoading: boolean;
  errorMessage: string;
};

export class RawConnectionForm extends React.Component<Props, State> {
  state: State = {
    email: '',
    password: '',
    shoulShowPassword: false,
    isLoading: false,
    errorMessage: '',
  };

  onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const { email, password } = this.state;
    this.setState({ isLoading: true });

    Auth.login({ email, password })
      .then(() => window.location.reload())
      .catch((error) => {
        const errorMessage = getErrorMessage(
          error.response,
          this.props.intl.formatMessage,
        );
        this.setState({
          errorMessage,
        });
      })
      .finally(() => {
        this.setState({ isLoading: false });
      });
  };

  render() {
    const { password, shoulShowPassword, isLoading, errorMessage } = this.state;
    const { switchToForgotPassword, intl } = this.props;
    return (
      <LoginForm onSubmit={this.onSubmit} data-test-id="form">
        <LoginFormGroup>
          <LoginInput
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              this.setState({ email: e.target.value })
            }
            value={this.state.email}
            placeholder={intl.formatMessage({
              id: 'ConnectionForm.tsx/1',
            })}
            type="email"
            autoComplete="email"
            id="modal_login_email"
            required
            spellCheck={false}
          />
        </LoginFormGroup>

        <LoginFormGroup>
          <LoginInput
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              this.setState({ password: e.target.value })
            }
            value={password}
            placeholder={intl.formatMessage({
              id: 'ConnectionForm.tsx/2',
            })}
            autoComplete="current-password"
            type={shoulShowPassword ? 'text' : 'password'}
            id="modal_login_password"
            name="password"
            required
            spellCheck={false}
          />
        </LoginFormGroup>
        <SwitchPassword
          showPassword={shoulShowPassword}
          onClick={() => {
            this.setState((state) => ({
              shoulShowPassword: !state.shoulShowPassword,
            }));
          }}
        />
        {!!errorMessage && <ConnectionError error={errorMessage} />}

        <LoginFormGroup>
          <LoginSubmit loading={isLoading} />
        </LoginFormGroup>
        <LoginForgot onClick={switchToForgotPassword} />
      </LoginForm>
    );
  }
}
export const ConnectionForm = injectIntl(RawConnectionForm);
